<template>
<div class="chapter">
<div class="inner_page">
<p class="head">Contents</p>
<p class="toc"><a href="#/Text/ack">Acknowledgements</a></p>
<p class="toc"><a href="#/Text/intro">Introduction: “Built for the Future”</a></p>
<p class="toc1"><span href="#/Text/chapter1" title="Link target outside of Sample">1. Origins of a Local Icon</span></p>
<p class="toc"><span href="#/Text/chapter2" title="Link target outside of Sample">2. “A Metropolitan Enterprise”</span></p>
<p class="toc"><span href="#/Text/chapter3" title="Link target outside of Sample">3. Postwar Boom</span></p>
<p class="toc"><span href="#/Text/chapter4" title="Link target outside of Sample">4. Soaring into the Sixties and Seventies</span></p>
<p class="toc"><span href="#/Text/chapter5" title="Link target outside of Sample">5. Rainbow’s End</span></p>
<p class="toc1"><span href="#/Text/epi" title="Link target outside of Sample">Epilogue: Hope in the City</span></p>
<p class="toc"><span href="#/Text/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Text/author" title="Link target outside of Sample">About the Authors</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?67809060